module.exports = __webpack_public_path__ + "static/media/MullerLight.fbb65c9c.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/MullerLight.otf
// module id = 1077
// module chunks = 0